import React, { useEffect } from "react"
import { useIntersectionObserver } from 'react-intersection-observer-hook';
import { motion, useAnimation } from "framer-motion";


const Reveal = (props) => {
  const { children, delay, duration, animation } = props;
  const [ref, { entry }] = useIntersectionObserver();
  const isVisible = entry && entry.isIntersecting;
  const controls = useAnimation()

  const initial = {
    'fade-in': {
      opacity: 0,
    },
    'slide-in': {
      opacity: 0,
      translateY: `6vh`,
    },
    'scale-in': {
      opacity: 0,
      scale: 0,
      rotate: 15,
      originX: 0.5,
      originY: 0.5,
      originZ: 25
    },
    'from-left': {
      opacity: 0,
      translateX: `-3vw`,
    },
    'from-right': {
      opacity: 0,
      translateX: `3vw`,
    }
  }

  const animations = {
    'fade-in': {
      opacity: 1,
      transition: {
        ease: "linear",
        duration: duration || 0.65,
        delay: delay
      }
    },
    'slide-in': {
      opacity: 1,
      translateY: 0,
      transition: {
        type: 'spring',
        damping: 20,
        mass: 1.95,
        delay: delay
      }
    },
    'scale-in': {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        type: 'spring',
        damping: 20,
        mass: 0.45,
        delay: delay
      }
    },
    'from-left': {
      opacity: 1,
      translateX: 0,
      transition: {
        ease: "easeOut",
        duration: duration || 1.5,
        delay: delay
      }
    },
    'from-right': {
      opacity: 1,
      translateX: 0,
      transition: {
        ease: "easeOut",
        duration: duration || 1.5,
        delay: delay
      }
    },
  }

  // will start the animation when visible
  useEffect(() => {
    if(isVisible) {
      controls.start({
        ...animations[animation],
      })
    }
  },[isVisible])

  return (
    <motion.div
      style={{
        display: props.display,
        height: '100%',
      }}
      ref={ref}
      animate={controls}
      initial={initial[animation]}
    >
      {children}
    </motion.div>
  );
}

Reveal.defaultProps = {
  display: 'block',
  delay: 0.5,
  duration: null,
  animation: 'slide-in'
}

export default Reveal;